import React, { useEffect, useState } from "react";
import { useNavigate, Link, Routes, Route } from "react-router-dom";
import globals from '../../Globals';
import DashboardEvents from './components/DashboardEvents';
import DashboardOverview from './components/DashboardOverview';
import DashboardUsers from './components/DashboardUsers';
import DashboardHero from './components/DashboardHero';
import { Bar, Pie, Line } from 'react-chartjs-2';
import { Users, CheckCircle, XCircle,  RefreshCw, Search, Filter } from 'lucide-react';
import { Calendar, MapPin, Plus, Trash2, Copy , Edit , Eye} from 'lucide-react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);
const API = globals.API;

export default function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) navigate("/login");
  }, [navigate]);
    const userName = localStorage.getItem('userName');
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const userEmail = localStorage.getItem("userEmail");

  return (
    <>
 <style>{`
 /* ============================================= */
/* RESPONSIVE DASHBOARD STYLES */
/* ============================================= */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dashboard-container {
  display: flex;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
  background: #f8fafc;
}

/* MODERN SIDEBAR */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  color: white;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
}

.sidebar-header {
  padding: 32px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: #d6d5f2ff;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
}

.logo-image {
  width: 90px;
  height: 90px;
  object-fit: contain;
  display: block;
  margin: 32px auto 16px auto;
  border-radius: 12px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #6366f1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.sidebar h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.sidebar-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  margin-top: 4px;
}

.sidebar-nav {
  flex: 1;
  padding: 24px 16px;
}

.nav-section {
  margin-bottom: 32px;
}

.nav-section-title {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
  padding: 0 12px 12px;
  margin-bottom: 4px;
}

.sidebar a, .nav-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  margin-bottom: 4px;
  transition: all 0.2s ease;
  font-weight: 500;
  font-size: 15px;
  position: relative;
}

.sidebar a::before, .nav-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: white;
  border-radius: 0 3px 3px 0;
  transition: height 0.2s ease;
}

.sidebar a:hover, .nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transform: translateX(2px);
}

.sidebar a.active, .nav-link.active {
  background: linear-gradient(90deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.1));
  color: white;
  font-weight: 600;
}

.sidebar a.active::before, .nav-link.active::before {
  height: 24px;
}

.nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  margin-bottom: 12px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: white;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logout-btn {
  width: 100%;
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.logout-btn:hover {
  background: rgba(239, 68, 68, 0.25);
  color: #fee2e2;
  transform: translateY(-1px);
}

/* MAIN CONTENT */
.main-content {
  margin-left: 280px;
  flex: 1;
  padding: 40px;
  overflow-y: auto;
  background: #f8fafc;
}

.topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e2e8f0;
}

.topbar h1 {
  font-size: 32px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.notification-btn {
  width: 40px;
  height: 40px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.notification-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  background: #ef4444;
  border-radius: 50%;
  border: 2px solid #f8fafc;
  font-size: 10px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ============================================= */
/* TABLET RESPONSIVENESS (≤1024px) */
/* ============================================= */
@media (max-width: 1024px) {
  .sidebar {
    width: 240px;
  }

  .main-content {
    margin-left: 240px;
    padding: 30px;
  }

  .topbar h1 {
    font-size: 28px;
  }

  .events-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)) !important;
  }

  .statsGrid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

/* ============================================= */
/* MOBILE RESPONSIVENESS (≤768px) */
/* ============================================= */
@media (max-width: 768px) {
  .dashboard-container {
    flex-direction: column;
  }

  /* Convert sidebar to bottom navigation */
  .sidebar {
    position: fixed;
    bottom: 0;
    left: 0;
    top: auto;
    width: 100%;
    height: auto;
    flex-direction: row;
    padding: 8px 12px;
    overflow-x: auto;
    overflow-y: hidden;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.12);
  }

  .sidebar-header,
  .nav-section-title {
    display: none !important;
  }

  .sidebar-footer {
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    display: flex !important;
    align-items: center;
  }

  .logout-btn {
    padding: 10px 12px !important;
    font-size: 11px !important;
    min-width: 70px !important;
    flex-direction: column;
    gap: 4px;
    height: auto !important;
  }

  .sidebar-nav {
    display: flex;
    padding: 0;
    gap: 8px;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  .nav-section {
    display: flex;
    gap: 8px;
    margin: 0;
    flex-direction: row;
  }

  .sidebar a, .nav-link {
    flex-direction: column;
    gap: 4px;
    padding: 10px 12px;
    min-width: 70px;
    text-align: center;
    font-size: 11px;
    margin: 0;
    white-space: nowrap;
  }

  .sidebar a::before, .nav-link::before {
    display: none;
  }

  .nav-icon {
    font-size: 20px;
  }

  /* Main content adjustments */
  .main-content {
    margin-left: 0;
    margin-bottom: 70px;
    padding: 20px;
    width: 100%;
  }

  .topbar {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding-bottom: 16px;
  }

  .topbar h1 {
    font-size: 24px;
  }

  .topbar-actions {
    width: 100%;
    justify-content: flex-end;
  }

  /* Events grid - single column */
  .events-grid {
    grid-template-columns: 1fr !important;
    gap: 16px !important;
  }

  /* Stats grid - single column */
  .statsGrid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  /* Filter section stack */
  .filters-container, .filterSection {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
  }

  .filter-select, .searchBox {
    width: 100% !important;
  }

  .clear-filters {
    margin-left: 0 !important;
  }

  /* Table responsiveness */
  .table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  /* Modal adjustments */
  .modal {
    padding: 12px !important;
  }

  .modalContent {
    max-width: 100% !important;
    max-height: 85vh !important;
  }

  .detailGrid {
    grid-template-columns: 1fr !important;
  }

  /* Button groups */
  .event-actions, .actionButtons {
    flex-wrap: wrap;
    gap: 8px !important;
  }

  .btn-edit, .btn-delete, .activateBtn {
    flex: 1 1 auto;
    min-width: 80px;
    font-size: 13px !important;
    padding: 8px 12px !important;
  }

  /* Chart containers */
  .ChartCard {
    min-height: 250px !important;
  }
}

/* ============================================= */
/* SMALL MOBILE (≤480px) */
/* ============================================= */
@media (max-width: 480px) {
  .main-content {
    padding: 16px;
    margin-bottom: 65px;
  }

  .topbar h1 {
    font-size: 20px;
  }

  .sidebar a, .nav-link {
    min-width: 60px;
    padding: 8px 10px;
    font-size: 10px;
  }

  .nav-icon {
    font-size: 18px;
  }

  /* Event cards */
  .event-card {
    border-radius: 8px !important;
  }

  .event-image-container {
    height: 160px !important;
  }

  .event-title {
    font-size: 16px !important;
  }

  .event-content {
    padding: 16px !important;
  }

  /* Stats cards */
  .statBox {
    padding: 12px !important;
  }

  .statValue {
    font-size: 24px !important;
  }

  /* Buttons */
  button {
    font-size: 13px !important;
    padding: 10px 16px !important;
  }

  /* Modal */
  .modalTitle {
    font-size: 18px !important;
  }

  .modalButtons {
    flex-direction: column !important;
    gap: 8px !important;
  }

  .confirmBtn, .cancelBtn {
    width: 100% !important;
  }

  /* Table - force scroll on small screens */
  .table {
    font-size: 13px !important;
  }

  .th, .td {
    padding: 10px 12px !important;
  }
}

/* ============================================= */
/* LANDSCAPE MODE (mobile) */
/* ============================================= */
@media (max-height: 600px) and (orientation: landscape) {
  .main-content {
    margin-bottom: 60px;
  }

  .sidebar {
    padding: 6px 12px;
  }

  .sidebar a, .nav-link {
    padding: 8px 10px;
    font-size: 10px;
  }
}

/* ============================================= */
/* FIX OVERFLOW ISSUES */
/* ============================================= */
@media (max-width: 768px) {
  * {
    max-width: 100vw;
    overflow-x: hidden;
  }

  .dashboard-container {
    overflow-x: hidden;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Prevent horizontal scroll */
  body {
    overflow-x: hidden;
  }
}`}</style>

      <div className="dashboard-container">
        {/* Fixed Sidebar */}
        <div className="sidebar">
  <div className="sidebar-header" style={{ background: "#d6d5f2ff",   width: "100", height: "60"
   }}>
    <div className="sidebar-logo">
      <img src="/assets/img/logo1.png" alt="Logo" className="logo-image" 
       style={{
    width: "90px",         // controls the logo's width
    height: "90px",        // controls the logo's height
    objectFit: "contain",  // keep aspect ratio, show all
    display: "block",
    margin: "32px auto 16px auto",
    borderRadius: "12px"
  }}
      />
  
    </div>
  </div>

  <nav className="sidebar-nav">
    <Link to="/dashboard" className="nav-link"> Overview</Link>
    <Link to="/dashboard/hero" className="nav-link"> Accueil</Link>
    <Link to="/dashboard/events" className="nav-link"> Events</Link>
    <Link to="/dashboard/users" className="nav-link"> Users</Link>
  </nav>

  <div className="sidebar-footer">
    <button className="logout-btn" onClick={handleLogout}>
      🚪 Logout
    </button>
  </div>
</div>


        {/* Main Content */}
        <div className="main-content">
          <div className="topbar">
            <h1>Bienvenue </h1> <br></br>
           
          </div>

          <Routes>
            <Route index element={<DashboardOverview />} />
            <Route path="events" element={<DashboardEvents />} />
            <Route path="hero" element={<DashboardHero />} />
            <Route path="users" element={<DashboardUsers />} />
          </Routes>
        </div>
      </div>
    </>
  );
}